import { Scales } from '../consts/Scales';

export default class ParallaxLayer extends Phaser.GameObjects.Container {
    constructor(scene, x, y, scrollSpeed) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.children = [];
        this.totalChildrenWidth = 0;
        this.scrollSpeed = scrollSpeed;
    }

    addTexture(textureKey) {
        let lastTexturePosition = 0;

        if (this.children.length > 0) {
            const lastChild = this.children[this.children.length - 1];
            lastTexturePosition = Math.round(lastChild.x + lastChild.displayWidth) - 1; // chevauchement anti-trou
        }

        const texture = this.scene.add
            .image(lastTexturePosition, this.scene.height, textureKey)
            .setOrigin(0, 1)
            .setName(textureKey)
            .setScale(Scales.scaleX, Scales.scaleY);

        // 🛑 Important : désactive l'anti-aliasing
        texture.setPipeline('Light2D'); // facultatif si tu as un pipeline personnalisé
        texture.setScaleMode(Phaser.ScaleModes.NEAREST);

        this.children.push(texture);
        this.add(texture);

        this.totalChildrenWidth += texture.displayWidth;
    }

    addTexture(textureKey) {
        let lastTexturePosition = 0;

        if (this.children.length > 0) {
            const lastChild = this.children[this.children.length - 1];
            lastTexturePosition = Math.round(lastChild.x + lastChild.displayWidth) - 2; // ou - 0.5
        }

        const texture = this.scene.add
            .image(lastTexturePosition, this.scene.height, textureKey)
            .setOrigin(0, 1);

        texture.setName(textureKey);
        this.children.push(texture);
        this.add(texture);

        this.totalChildrenWidth += texture.displayWidth;
    }

    moveParallax(delta) {
        this.children.forEach((texture) => {
            texture.x -= this.scrollSpeed * (delta / 1000) * Scales.scaleX;
        });

        this.children.forEach((texture) => {
            if (texture.x + texture.displayWidth <= 0) {
                // Trouver la texture la plus à droite
                const rightMost = this.children.reduce((max, child) =>
                    child.x > max.x ? child : max
                );

                // 🔁 Colle exactement après celle la plus à droite
                texture.x = Math.round(rightMost.x + rightMost.displayWidth);
            }
        });
    }

    setParallaxLayerTexture(index, textureKey) {
        this.children[index].setTexture(textureKey);
    }
}
